import { ESAT_OPTIONAL_ORDER, resolveEsatPickerCommit } from './esatModulePicker';

/** Optional module keys to restore when continuing an ESAT/ENGAA/NSAA sitting. */
export function resolveEsatContinueOptionalKeys({
  storedKeys = [],
  heritageExam,
  year,
  optionals = {},
  attemptedPaperIds = [],
} = {}) {
  const stored = (storedKeys || []).filter(Boolean).map(String);
  if (stored.length) return stored;

  const commit = resolveEsatPickerCommit({ heritageExam, year, optionals });
  if (commit.persistKeys.length) return commit.persistKeys;

  const attempted = new Set((attemptedPaperIds || []).map(String));
  return ESAT_OPTIONAL_ORDER.filter((key) => {
    const id = optionals?.[key]?.id;
    return id && attempted.has(String(id));
  });
}
